export default {
  apiKey: 'AIzaSyDWjKpXkvEDm_wOwS95HGi5ug-dE6LM5bo',
  authDomain: 'bsg-results-app.firebaseapp.com',
  projectId: 'bsg-results-app',
  storageBucket: 'bsg-results-app.appspot.com',
  messagingSenderId: '673769577321',
  appId: '1:673769577321:web:562d2be69cc7344180fbf8',
  measurementId: 'G-C7W005P0VT',
};
